import { withNamespaces } from 'react-i18next';
import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Spinner,
    UncontrolledDropdown,
} from 'reactstrap';

import {
    SHOW_MAILBOX_BULK_ACTIONS,
} from '../../../helpers';

const MessageToolbar = ({
    t,
    folder = 'inbox',
    selectedCount = 0,
    intents = [],
    onBulkTrash,
    onBulkRestore,
    onBulkRead,
    onBulkUnread,
    onBulkStar,
    onApplyIntent,
    onSync,
    isActing = false,
    isSyncing = false,
}) => {
    const isTrash = folder === 'trash';
    const hasSelection = selectedCount > 0;
    const actionsDisabled = isActing || isSyncing;

    return (
        <div className="mailbox-toolbar">
            {SHOW_MAILBOX_BULK_ACTIONS ? (
                <div className="mailbox-toolbar__actions">
                    <Button
                        color="primary"
                        className="mailbox-toolbar__btn"
                        title={isTrash ? t('Restore') : t('Move to Trash')}
                        disabled={actionsDisabled}
                        onClick={isTrash ? onBulkRestore : onBulkTrash}
                    >
                        <i className={`mdi ${isTrash ? 'mdi-delete-restore' : 'mdi-trash-can-outline'}`} />
                    </Button>
               

                    {/*
                    <UncontrolledDropdown>
                        <DropdownToggle
                            color="primary"
                            caret={false}
                            disabled={actionsDisabled}
                            className="mailbox-toolbar__btn mailbox-toolbar__tag"
                            title={t('Tag')}
                        >
                            <i className="mdi mdi-tag" />
                            <i className="mdi mdi-dots-vertical" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                header
                                className="d-flex align-items-center"
                            >
                                {t('Add Label as')}
                            </DropdownItem>
                            {intents.map((item) => (
                                <DropdownItem
                                    key={item.code}
                                    disabled={!hasSelection || actionsDisabled}
                                    onClick={() => onApplyIntent?.(item.code)}
                                >
                                    {t(item.titleKey)}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    */}

                    <UncontrolledDropdown>
                        <DropdownToggle
                            color="primary"
                            caret={false}
                            disabled={actionsDisabled}
                            className="mailbox-toolbar__btn mailbox-toolbar__more"
                        >
                            {t('More')}
                            <i className="mdi mdi-dots-vertical" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                disabled={!hasSelection || actionsDisabled}
                                onClick={onBulkUnread}
                            >
                                {t('Mark as unread')}
                            </DropdownItem>
                            <DropdownItem
                                disabled={!hasSelection || actionsDisabled}
                                onClick={onBulkRead}
                            >
                                {t('Mark as read')}
                            </DropdownItem>
                            <DropdownItem
                                disabled={!hasSelection || actionsDisabled}
                                onClick={onBulkStar}
                            >
                                {t('Mark as starred')}
                            </DropdownItem>
                            {isTrash ? (
                                <DropdownItem
                                    disabled={!hasSelection || actionsDisabled}
                                    onClick={onBulkRestore}
                                >
                                    {t('Restore')}
                                </DropdownItem>
                            ) : null}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            ) : null}

            <Button
                type="button"
                color="primary"
                className="mailbox-toolbar__sync"
                disabled={isSyncing || isActing}
                onClick={onSync}
            >
                {isSyncing ? (
                    <Spinner
                        size="sm"
                    />
                ) : (
                    <i className="mdi mdi-refresh" />
                )}
                {t('Sync')}
            </Button>
        </div>
    );
};

export default withNamespaces()(MessageToolbar);
